/*
 * 外部ブラウザの「LINE に戻る」リンクのクエリ名。
 * Sentry の送信前マスク（sentry.client.config.ts）からも参照するため、依存の無いこのファイルに置く。
 */
export const RETURN_NONCE_PARAM = 'lineSocialLoginNonce'
export const RETURN_CODE_PARAM = 'lineSocialLoginCode'
